import { observer } from 'mobx-react-lite';
import { Alert, CircularProgress } from '@mui/material';

import { useRootStore } from 'stores/RootStore';

import { Header } from 'components/Header';
import { Footer as CommonFooter } from 'components/Footer';
import { JobDetails } from './JobDetails';

const DiligencePage = observer(() => {
  const { diligencePageStore } = useRootStore();
  const { loadStatus, diligenceStore, propertyCoordinatesAreLoading, propertyCoordinates } = diligencePageStore;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <div style={{ flex: 1, overflowY: 'scroll', display: 'flex', flexDirection: 'column', height: '100vh' }}>
        <Header />
        {loadStatus === 'error' && <Alert severity="error">There was an error loading this job.</Alert>}
        {loadStatus === 'dropboxError' && <Alert severity="error">No Dropbox URL is configured for this job.</Alert>}
        {loadStatus === 'loading' && <CircularProgress sx={{ marginTop: '24px', alignSelf: 'center' }} />}

        {diligenceStore && (
          <JobDetails
            diligenceStore={diligenceStore}
            propertyCoordinatesAreLoading={propertyCoordinatesAreLoading}
            propertyCoordinates={propertyCoordinates}
          />
        )}
      </div>
      <CommonFooter />
    </div>
  );
});

export { DiligencePage };
